import createFetchedSaga from './fetchedSaga';

const higherOrderSaga = {
	createFetchedSaga
}
export default higherOrderSaga;